<form #currentForm="ngForm" (submit)="submitForm(currentForm.form.valid)" novalidate>
  <fieldset>
    <div class="form-group">
      <label>Name</label>
      <input type="text" required [uniqueValidator]="'setting_types?setting_group_id=' + this.settingType.setting_group_id + (settingType.id ? '&id=' + settingType.id : '')" placeholder="Name" class="form-control" [(ngModel)]="settingType.name" name="name" #name="ngModel" />
      <div class="alert alert-danger alert-padding-sm" *ngIf="fieldShowErrorMessage(name)">{{ fieldBuildErrorMessage(name, 'Name') }}</div>
    </div>
    <div class="form-group">
      <label>Description</label>
      <textarea placeholder="description" class="form-control" [(ngModel)]="settingType.description" name="description" #description="ngModel"></textarea>
    </div>
    <div class="form-group">
      <button type="submit" [disabled]="formSubmitting" class="btn btn-primary">
        {{ settingType.id ? 'Save' : 'Add' }}
      </button>
      &nbsp;
      <button type="button" (click)="this.formEvent.emit('Form Cancelled')" class="btn btn-secondary">Cancel</button>
    </div>
  </fieldset>
</form>
